import { pick } from 'lodash';
import { StyleSheet } from 'react-native';

const createStyles = (attributes: any) => {
  return StyleSheet.create({
    container: {
      ...pick(attributes, ['marginTop', 'marginLeft', 'width']),
      // Use exact height when clipContent is true, otherwise use minHeight
      ...(attributes.clipContent
        ? { height: attributes.height }
        : { minHeight: attributes.height }),
      zIndex: attributes.zIndex,
    },
  });
};

export default createStyles;
